import { fetchFlask } from '../../utils/fetchFlask';
import { formatInteger, ratio } from '../../utils/numberUtils';
import { formatCurrency } from '../../utils/stringFormat';
import { buildInadimplenciaKpis } from '../biGE/inadimplenciaData';

export const fetchDashboardCobranca = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('dashboardCobranca', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.dashboard;
};

export const buildDashboardCobrancaGauges = ({ inadimplencia, acordos, serasa }, periodQuery) => [
    {
        key: 'inadimplencia',
        title: 'Inadimplência',
        value: buildInadimplenciaKpis(inadimplencia).percentualAtrasadoValor,
        max: 0.15,
        meta: 0.028,
        lowerIsBetter: true,
        detail: `${formatCurrency(inadimplencia.total_atrasado)} de ${formatCurrency(inadimplencia.total_faturado)}`,
        to: `BICOB/inadimplencia${periodQuery}`
    },
    {
        key: 'inadimplenciaAcordos',
        title: 'Inadimplência acordos',
        value: ratio(acordos.total_atrasado, acordos.total),
        max: 0.5,
        meta: 0.15,
        lowerIsBetter: true,
        detail: `${formatCurrency(acordos.total_atrasado)} em atraso`,
        to: 'BICOB/acordos'
    },
    {
        key: 'negativados',
        title: 'Negativados',
        value: ratio(serasa.quantidade_negativados, serasa.quantidade_negativaveis),
        meta: 1,
        detail: `${formatInteger(serasa.quantidade_negativados)} de ${formatInteger(serasa.quantidade_negativaveis)} títulos`,
        to: 'BICOB/listaSerasa'
    },
    {
        key: 'baixados',
        title: 'Baixados',
        value: ratio(serasa.quantidade_baixados, serasa.quantidade_baixaveis),
        meta: 1,
        detail: `${formatInteger(serasa.quantidade_baixados)} de ${formatInteger(serasa.quantidade_baixaveis)} títulos`,
        to: 'BICOB/listaSerasa'
    }
];
